import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Trophy, Calendar, Flame } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { trashMissions } from "@/lib/trashApi";

export default function TrashMissions() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => { if (user) trashMissions().then(setData).catch(() => {}); }, [user]);

  if (!user) return (
    <div className="py-16 text-center">
      <div className="font-black text-2xl mb-2">Sign in to see missions</div>
      <Link to="/login?next=/trashhunter/missions" className="inline-flex items-center gap-1 bg-[#39FF14] text-black font-black text-xs uppercase tracking-widest px-5 py-2.5 rounded-full mt-3">Sign in</Link>
    </div>
  );
  if (!data) return <div className="py-16 text-center text-white/40"><Loader2 className="w-5 h-5 animate-spin mx-auto" /></div>;

  return (
    <div className="space-y-6" data-testid="trash-missions">
      <Section title="Daily missions" subtitle={`Resets midnight UTC · ${data.day}`} icon={<Calendar className="w-4 h-4" />} items={data.daily} />
      <Section title="Weekly missions" subtitle={`Resets end of week · ${data.week}`} icon={<Trophy className="w-4 h-4" />} items={data.weekly} />
      <div className="rounded-2xl border border-white/10 bg-white/5 p-3 text-xs text-white/60">
        Mission rewards are auto-awarded when the goal is met — no need to claim.
      </div>
    </div>
  );
}

function Section({ title, subtitle, icon, items }) {
  return (
    <section>
      <div className="mb-2 flex items-center gap-2">
        <div className="w-7 h-7 rounded-lg bg-[#39FF14]/15 text-[#39FF14] flex items-center justify-center">{icon}</div>
        <div className="flex-1">
          <div className="font-black text-sm uppercase tracking-widest">{title}</div>
          <div className="text-[10px] text-white/50">{subtitle}</div>
        </div>
      </div>
      <div className="space-y-2">
        {items.map((m) => (
          <div key={m.key} data-testid={`mission-${m.key}`}
            className={"rounded-2xl border p-4 " + (m.completed ? "border-[#39FF14]/40 bg-[#39FF14]/10" : "border-white/10 bg-black/40")}>
            <div className="flex items-center gap-2">
              <div className="flex-1 min-w-0">
                <div className="font-black text-sm">{m.title}</div>
                <div className="text-xs text-white/60">{m.description}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="font-black text-lg tabular-nums">{m.progress}/{m.goal}</div>
                <div className="text-[9px] mono uppercase tracking-widest text-[#39FF14]">+{m.reward_xp} XP · +{m.reward_coins} c</div>
              </div>
            </div>
            <div className="mt-2 h-1.5 bg-white/10 rounded-full overflow-hidden">
              <div className="h-full bg-[#39FF14]" style={{ width: `${Math.min(100, (m.progress / m.goal) * 100)}%` }} />
            </div>
            {m.completed && <div className="mt-2 text-[10px] mono uppercase tracking-widest text-[#39FF14]">✓ Complete</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
